import './Support.css';
import monogram from './images/monogram-blue.svg';

function Support() {
  return (
    <div className="support">
      <div className="container">
        <img className="monogram" src={monogram} alt="" />
        <h1>Support</h1>
        <p>
          Need help with the Happily Ever After app or website? We&apos;re happy to help.
        </p>
        <p>
          Email us at <a href="mailto:mail@oliverbinns.co.uk">mail@oliverbinns.co.uk</a> and include a short description of your issue.
        </p>
        <p>
          We&apos;ll respond as soon as possible.
        </p>
      </div>
    </div>
  );
}

export default Support;
